import React, { useContext, useEffect, useState, useRef } from 'react';
import cx from 'classnames';
import { ZendeskChatContext, BrokerContext } from '@qover/contexts';
import { Trans } from '@lingui/macro';
import { SecondaryButton } from '@qover/molecules';
import { useMedia, useOutsideClick } from '@qover/hooks';
import PhoneIcon from './icons/PhoneIcon';
import { SupportCenterModal } from './SupportCenterModal';
import { SupportCenterButtonContainer } from './SupportCenter.styles';

const CLOSED = 'closed';
const OPENED = 'opened';

type SupportCenterButtonProps = {
  Button?: any;
  className?: string;
  Modal?: any;
  phone?: string;
  email?: string;
  showChat?: () => void;
};

export function SupportCenterButton(props: SupportCenterButtonProps) {
  const zendesk = useContext(ZendeskChatContext);
  const broker = useContext(BrokerContext);
  const {
    phone = broker?.informations?.general?.phone ?? '',
    email = broker?.informations?.general?.email ?? '',
    showChat,
    className,
    Modal = SupportCenterModal,
    Button = SecondaryButton,
  } = props;

  const [isModalOpen, setModalOpen] = useState(false);
  const previousModalStatus = useRef(isModalOpen);
  const [isLoaded, setLoaded] = useState(false);

  const ref = useOutsideClick(() => setModalOpen(false));
  const isMobile = useMedia(['(max-width: 767px)'], [true], false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (isModalOpen || previousModalStatus.current) {
      // @ts-ignore
      dataLayer.push({
        event: 'contactEvent',
        eventCategory: 'Contact',
        eventAction: isModalOpen ? OPENED : CLOSED,
        eventLabel: 'box',
      });
    }
    previousModalStatus.current = isModalOpen;
  }, [isModalOpen]);

  return (
    <SupportCenterButtonContainer
      className={cx(className, { open: isModalOpen })}
      ref={ref}
    >
      {isLoaded && (
        <Button
          data-test="topBar.supportCenterButton"
          onClick={() => {
            setModalOpen(!isModalOpen);
          }}
          round={isMobile}
          renderBefore={() => isMobile && <PhoneIcon />}
        >
          {!isMobile && <Trans id="nav.contactus" />}
        </Button>
      )}
      <Modal
        zendesk={zendesk}
        phone={phone}
        email={email}
        showChat={showChat}
        key={isModalOpen}
      />
    </SupportCenterButtonContainer>
  );
}

export default SupportCenterButton;
